import { render, staticRenderFns } from "./ForumSearchResults.vue?vue&type=template&id=21a07528&scoped=true"
import script from "./ForumSearchResults.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumSearchResults.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumSearchResults.vue?vue&type=style&index=0&id=21a07528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a07528",
  null
  
)

export default component.exports